import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { Contract } from '@models/contract';
import { ContractWidget } from '@models/contract-widgets';
import { Insurant } from '@models/insurant';
import { PortalCollapsibleComponent, PortalWidgetDetailsComponent } from 'app/customer-portal';
import { InsurantFullNamePipe } from 'app/shared/pipes/insurant-full-name.pipe';
import { parse } from 'date-fns';

type InsurantRole = 'Versicherungsnehmer' | 'Versicherte Person' | 'Mitversichertes Kind';

interface InsurantforDisplay extends Insurant {
    role: InsurantRole;
    dateOfBirthTimestamp: number;
}

@Component({
    selector: 'app-ausland-kv-widget',
    templateUrl: './ausland-kv-widget.component.html',
    styleUrl: './ausland-kv-widget.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PortalCollapsibleComponent, PortalWidgetDetailsComponent, InsurantFullNamePipe],
})
export class AuslandKVWidgetComponent implements ContractWidget {
    public contract = input.required<Contract>();

    protected insurants = computed(() =>
        this.contract()
            .insurants.map((insurant) => ({
                ...insurant,
                role: this.getRole(insurant),
                dateOfBirthTimestamp: this.getTimestamp(insurant),
            }))
            .sort(compareInsurants),
    );

    private getRole(insurant: Insurant): InsurantRole {
        if (insurant.isInsuree) {
            return 'Versicherungsnehmer';
        } else if (insurant.isChild) {
            return 'Mitversichertes Kind';
        }
        return 'Versicherte Person';
    }

    private getTimestamp(insurant: Insurant): number {
        const dateComponents = insurant.dateOfBirth.split('.');
        if (dateComponents.length !== 3) {
            throw Error('Unexpected Date of Birth format');
        }
        return parse(insurant.dateOfBirth, 'd.M.y', new Date()).getTime();
    }
}

function compareInsurants(insurantA: InsurantforDisplay, insurantB: InsurantforDisplay): number {
    if (insurantA.isInsuree) {
        return -1;
    }
    if (insurantB.isInsuree) {
        return 1;
    }
    return insurantA.dateOfBirthTimestamp - insurantB.dateOfBirthTimestamp;
}
